<template>
  <div class="alert-wrapper">
    <div class="vote-bg-box">
      <img class="vote-bg" :src="require('../../assets/imgs/vote/vote_bg.png')" alt="">
    </div>
    <div class="content-box">
      <!-- 阅读文章前 -->
      <img class="vote-scene" :src="require('../../assets/imgs/vote/before.png')" alt="">
      <vote-progress :percent="voteSummary.beforeAgreePercent"></vote-progress>
      <div class="vote-text" v-if="voteSummary.beforeViewpoint == 1">你选择了“A：Agree”</div>
      <div class="vote-text" v-else-if="voteSummary.beforeViewpoint == 2">你选择了“B：Disagree”</div>
      <div class="vote-text" v-else>你未做选择</div>
      <!-- 阅读文章后 -->
      <img class="vote-scene" :src="require('../../assets/imgs/vote/after.png')" alt="">
      <vote-progress :percent="voteSummary.afterAgreePercent"></vote-progress>
      <div class="vote-text" v-if="voteSummary.afterViewpoint == 1">你选择了“A：Agree”</div>
      <div class="vote-text" v-else-if="voteSummary.afterViewpoint == 2">你选择了“B：Disagree”</div>
      <div class="vote-text" v-else>你未做选择</div>
      <!-- 分享给朋友 -->
      <img class="vote-share" :src="require('../../assets/imgs/vote/vote_share.png')" alt="" @click="onClickVoteShare()">
    </div>
  </div>
</template>

<script>
  import VoteProgress from './VoteProgress'
  export default {
    name: "VoteSummaryAlert",
    props: {
      voteSummary: {
        type: Object
      }
    },
    components: {
      VoteProgress,
    },
    data() {
      return {
      };
    },
    methods: {
      onClickVoteShare() {
        this.$emit('onClickVoteShare')
      }
    }
  };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .alert-wrapper {
    width calc(100vw - 20px)
    height calc((100vw - 20px) * 580 / 345)
    max-height 80vh
    box-sizing border-box
    border-radius 12px

    .vote-bg-box {
      border-radius 12px
      width 100%
      height 100%
      position absolute
      overflow hidden
      
      .vote-bg {
        width 100%
        position absolute
        bottom   0
      }
    }

    .content-box {
      position absolute
      width 100%
      height 100%
      display flex
      flex-direction column
      align-items center
      justify-content flex-end

      .vote-scene {
        width 185px
      }

      .vote-text {
        font-size 11px
        color #ffffff
        margin-top 17px
        margin-bottom 25px
        font-family serif,SimSun,STSong
      }

      .vote-share {
        width calc(100% - 50px)
        margin-bottom 30px
      }
    }
  }
</style>


// WEBPACK FOOTER //
// app/components/vote/VoteSummaryAlert.vue